let events = {

    FOOTER_DATA_UPDATED: 'footer:data:updated',
    MONITORING_DATA_UPDATED: 'monitoring:data:updated',
    SHOW_SPINNER: 'spinner:show',
    HIDE_SPINNER: 'spinner:hide',
    CANCEL_SPINNER: 'spinner:cancel',

    USER_CHANGED: 'user:changed',
    USER_LOGOUT: 'user:logout', //confirmDiscard (true/false)

    FOOTER_REFRESH: 'footer:refresh',

    ACTIVATE_TREE_SEARCH: 'tree:search:activate',
    TREE_SEARCH_CHANGE: 'tree:search:change',
    TREE_SEARCH_KEYDOWN: 'tree:search:keydown',
    TREE_SEARCH_CANCEL: 'tree:search:cancel',
    TREE_SEARCH_RUNNING: 'tree:search:running',

    COMPONENT_SELECT: 'component:select',

    ALERTS_REFRESH: 'alerts:refresh',
    BUNDLES_REFRESH: 'bundles:refresh',
    INSTANCES_REFRESH: 'instances:refresh',
    UPDATE_STATUS_CHANGE: 'update:status:change',
	UPDATE_STATUS_FETCHED: 'update:status:fetched',
    UPDATE_LOG_DATA: 'update:log:data',
    COMPONENT_DATA_UPDATED: 'component:data:updated',
    COMPONENT_VERSION_SELECTED: 'component:version:selected',
    REFRESH_PAGE_CONTENT: 'refresh:page:content',
    CUSTOM_ISSUE_ADDED: 'custom:issue:added',
    GENERAL_DETAILS_RECIEVED: 'general:details:recieved',
    CUSTOM_ISSUE_INJECTED: 'custom:issue:injected',
    PERMISSION_CHANGED: 'permission:changed',
    WIZARD_TAB_CHANGE: 'wizard:tab:change',
    CUSTOM_LICENSE_ASSIGNED: 'custom:license:assigned'

};

export default events;



// WEBPACK FOOTER //
// ./modules/xray/constants/xray-ui_events.constants.js